import { useTimeAttention } from './api';

/**
 * "N weeks are waiting on you."
 *
 * The Approvals view was discoverable only by an approver who happened to open
 * /time — a Friday workflow nobody is prompted into is a Friday workflow nobody
 * runs. This puts the count on the Time nav item, where an approver sees it
 * without going looking.
 *
 * ⚠ **IT USED TO COUNT THE CURRENT WEEK ONLY.** It asked the roster about
 * `mondayOf(today)`, so four sheets submitted last Monday were invisible in a
 * badge whose entire job is to say how many are waiting — the badge read 3 while
 * 7 sheets actually sat unapproved. It now reads `/time/attention`, the SAME
 * query the strip on /time renders, so the two can never print different
 * numbers and the sidebar makes no request of its own.
 *
 * It stays free for the people it does not concern: the server decides who may
 * review, and the approval section of that payload is empty (never 403) for
 * everybody else.
 */
export function useApprovalsAwaiting(): number {
  const attention = useTimeAttention();
  return attention.data?.awaiting.count ?? 0;
}
